"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _storage = require("@/api/storage");
var _rule = require("@/api/rule");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function extractUniqueObjectsByProp(arr1, arr2, prop) {
  // 使用Set存储第二个数组中对象的prop值，便于快速查找。
  var set2 = new Set(arr2.map(function (obj) {
    return obj[prop];
  }));
  // 过滤第一个数组中不在set2中的对象。
  return arr1.filter(function (obj1) {
    return !set2.has(obj1[prop]);
  });
}
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    MultiLanguageInp: _MultiLanguageInp.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      tabsAll: [],
      tabsOne: [],
      activeNameOne: '',
      tabsTwo: [],
      activeNameTwo: '',
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        sort: 'add_time',
        order: 'desc'
      },
      total: 0,
      list: [],
      dialogStatus: '',
      dialogFormVisible: false,
      dialogTitle: '',
      required: {
        required: true,
        message: '类目名称不能为空',
        trigger: 'change'
      },
      requiredName: {
        required: true,
        message: '标题不能为空',
        trigger: 'change'
      },
      dataForm: {
        id: undefined,
        name: '',
        sort: ''
      },
      ruleFormVisible: false,
      LanguageList: [],
      ruleForm: {
        id: undefined,
        name: '',
        status: 1
      },
      initRuleForm: {},
      oldTabsOne: [],
      oldTabsTwo: []
    };
  },
  computed: {
    rules: function rules() {
      return {
        name: [this.required]
      };
    },
    DetailRules: function DetailRules() {
      var rules = {
        name: [this.requiredName],
        zh: [{
          required: true,
          message: '中文规则文件为必填项',
          trigger: ['blur', 'change', 'input']
        }],
        en: [{
          required: true,
          message: '英文规则文件为必填项',
          trigger: ['blur', 'change', 'input']
        }]
      };
      return rules;
    }
  },
  mounted: function mounted() {
    this.getLanguageList();
    this.getList();
  },
  methods: {
    getLanguageList: function getLanguageList() {
      var _this = this;
      (0, _rule.languageList)().then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this.LanguageList = dataRes.data;
          var fileUrl = {};
          dataRes.data.forEach(function (ele) {
            fileUrl[ele.label] = '';
          });
          var form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.ruleForm), fileUrl);
          _this.ruleForm = (0, _objectSpread2.default)({}, form);
          _this.initRuleForm = (0, _objectSpread2.default)({}, form);
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this2 = this;
      this.ruleForm = Object.assign({}, row);
      var urlLang = this.LanguageList.map(function (lang) {
        return lang.label;
      });
      var URL = JSON.parse(this.ruleForm.url);
      urlLang.forEach(function (url) {
        _this2.ruleForm[url] = URL[url] ? URL[url] : '';
      });
      this.dialogTitle = '编辑';
      this.dialogStatus = 'update';
      this.ruleFormVisible = true;
      // 在下一个事件循环中清除表单校验状态
      this.$nextTick(function () {
        if (_this2.$refs.ruleForm) {
          _this2.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm('是否要删除该规则', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _rule.deleteArticle)({
          id: row.id
        }).then(function (response) {
          var dataRes = response.data;
          if (dataRes.errno === 0) {
            _this3.getRuleList();
            _this3.$message.success('删除成功');
          }
        }).catch(function (response) {
          _this3.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    // 上传文件之前判断是否为PDF文件
    beforeUpload: function beforeUpload(file) {
      var isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('上传文件只能是 PDF 格式!');
      }
      return isPDF;
    },
    handleUpload: function handleUpload(item, lang) {
      var _this4 = this;
      var formData = new FormData();
      formData.append('file', item.file);
      var name = 'upload' + lang.id;
      this.$refs[name][0].clearFiles();
      var form = (0, _objectSpread2.default)({}, this.ruleForm);
      (0, _storage.createStorage)(formData).then(function (response) {
        form[lang.label] = response.data.data.url;
        _this4.ruleForm = (0, _objectSpread2.default)({}, form);
        // 触发该字段的验证
        _this4.validateField(lang.label);
        _this4.$notify.success({
          title: '成功',
          message: '上传成功'
        });
      }).catch(function () {
        _this4.$message.error('上传失败，请重新上传');
      });
    },
    getList: function getList() {
      var _this5 = this;
      (0, _rule.listMenu)().then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this5.tabsAll = dataRes.data;
          var tabsOne = [];
          if (dataRes.data.length > 0) {
            dataRes.data.forEach(function (ele) {
              var id = ele.id,
                menuName = ele.menuName;
              tabsOne.push({
                name: id + '',
                label: menuName
              });
            });
            _this5.tabsOne = tabsOne;
            if (_this5.oldTabsOne.length > 0) {
              _this5.activeNameOne = extractUniqueObjectsByProp(tabsOne, _this5.oldTabsOne, 'name')[0].name;
            } else {
              _this5.activeNameOne = tabsOne.filter(function (ele) {
                return ele.name === _this5.activeNameOne;
              }).length > 0 ? _this5.activeNameOne : _this5.tabsOne[0].name;
            }
            _this5.getListTwo(_this5.activeNameOne);
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getListTwo: function () {
      var _getListTwo = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(key) {
        var _this6 = this;
        var target, tabsTwo;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              target = this.tabsAll.filter(function (ele) {
                return ele.id + '' === key;
              });
              if (target.length > 0 && target[0].children && target[0].children.length > 0) {
                tabsTwo = [];
                target[0].children.forEach(function (ele) {
                  var id = ele.id,
                    menuName = ele.menuName;
                  tabsTwo.push({
                    name: id + '',
                    label: menuName
                  });
                });
                this.tabsTwo = tabsTwo;
                if (this.oldTabsTwo.length > 0) {
                  this.activeNameTwo = extractUniqueObjectsByProp(tabsTwo, this.oldTabsTwo, 'name')[0].name;
                } else {
                  this.activeNameTwo = tabsTwo.filter(function (ele) {
                    return ele.name === _this6.activeNameTwo;
                  }).length > 0 ? this.activeNameTwo : this.tabsTwo[0].name;
                }
              } else {
                this.tabsTwo = [];
                this.activeNameTwo = '';
              }
              _context.n = 1;
              return this.getRuleList();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getListTwo(_x) {
        return _getListTwo.apply(this, arguments);
      }
      return getListTwo;
    }(),
    getRuleList: function getRuleList() {
      var _this7 = this;
      var menuId = this.activeNameTwo ? this.activeNameTwo : this.activeNameOne;
      (0, _rule.pageArticle)({
        menuId: menuId,
        page: this.listQuery.page,
        size: this.listQuery.limit
      }).then(function (res) {
        var dataRes = res.data;
        _this7.listLoading = false;
        if (dataRes.errno === 0) {
          dataRes.data.list.forEach(function (ele) {
            var target = _this7.tabsAll.filter(function (ele) {
              return ele.id + '' === _this7.activeNameOne;
            });
            ele.tabOneId = target[0].id;
            ele.tabOneName = target[0].menuName;
            if (_this7.activeNameTwo) {
              var currentTarget = target[0].children.filter(function (ele) {
                return ele.id + '' === _this7.activeNameTwo;
              });
              ele.tabTwoName = currentTarget[0].menuName;
            } else {
              ele.tabTwoName = '';
            }
          });
          _this7.list = dataRes.data.list;
        }
      });
    },
    // 切换一级类目
    handleClickOne: function handleClickOne(tab, event) {
      this.getListTwo(tab.name);
    },
    // 切换二级类目
    handleClickTwo: function handleClickTwo(tab, event) {
      this.getRuleList();
    },
    // 新增类目
    Add: function Add(type) {
      this.dialogStatus = 'create';
      this.dataForm = {
        id: undefined,
        name: '',
        sort: ''
      };
      if (type === 1) {
        // 一级类目
        this.dialogTitle = '新增一级类目';
        this.dialogFormVisible = true;
      } else if (type === 2) {
        // 二级类目
        if (this.activeNameOne && this.tabsOne.length > 0) {
          this.dialogTitle = '新增二级类目';
          this.dialogFormVisible = true;
          this.dataForm.pid = this.activeNameOne;
        } else {
          return this.$message.error('需要新建一级类目');
        }
      }
    },
    // 编辑类目
    Edit: function Edit(type) {
      var _this8 = this;
      this.dialogStatus = 'update';
      if (type === 1) {
        // 一级类目
        if (this.activeNameOne && this.tabsOne.length > 0) {
          this.dialogTitle = '编辑一级类目';
          var target = this.tabsAll.filter(function (ele) {
            return ele.id + '' === _this8.activeNameOne;
          });
          this.dataForm.id = target[0].id + '';
          this.dataForm.name = target[0].menuName;
          this.dataForm.sort = target[0].sort;
          this.dialogFormVisible = true;
        } else {
          return this.$message.error('需要新建一级类目');
        }
      } else if (type === 2) {
        // 二级类目
        if (this.activeNameTwo && this.tabsTwo.length > 0) {
          this.dialogTitle = '编辑二级类目';
          this.dialogFormVisible = true;
          // 指定的一级
          var _target = this.tabsAll.filter(function (ele) {
            return ele.id + '' === _this8.activeNameOne;
          });
          // 指定的二级
          var currentTarget = _target[0].children.filter(function (ele) {
            return ele.id + '' === _this8.activeNameTwo;
          });
          this.dataForm.id = currentTarget[0].id + '';
          this.dataForm.name = currentTarget[0].menuName;
          this.dataForm.sort = currentTarget[0].sort;
        } else {
          return this.$message.error('需要新建二级类目');
        }
      }
    },
    onSaveMenu: function onSaveMenu(type) {
      var _this9 = this;
      if (!this.dataForm.name) return this.$message.error('类目名称不能为空');
      var params = {
        menuName: this.dataForm.name,
        sort: this.dataForm.sort
      };
      if (this.dataForm.pid) {
        params.pid = this.dataForm.pid;
      }
      // type =1 新增 ; =2 编辑
      if (type === 2 && this.dataForm.id) {
        params.id = this.dataForm.id;
      }
      (0, _rule.saveMenu)(params).then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          if (type === 1) {
            // 新增情况下记住旧的类目
            if (_this9.dataForm.pid) {
              _this9.oldTabsOne = [];
              _this9.oldTabsTwo = _this9.tabsTwo;
            } else {
              _this9.oldTabsOne = _this9.tabsOne;
              _this9.oldTabsTwo = [];
            }
          } else {
            _this9.oldTabsOne = [];
            _this9.oldTabsTwo = [];
          }
          _this9.getList();
          _this9.dataForm = {
            id: undefined,
            name: '',
            sort: ''
          };
          _this9.dialogFormVisible = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 删除类目
    Delete: function Delete(type) {
      var _this0 = this;
      var name = '';
      var id = '';
      if (type === 1) {
        // 一级类目
        name = this.activeNameOne && this.tabsOne.length > 0 ? this.tabsOne.filter(function (ele) {
          return ele.name === _this0.activeNameOne;
        })[0].label : '';
        id = this.activeNameOne;
      } else if (type === 2) {
        // 二级类目
        name = this.activeNameTwo && this.tabsTwo.length > 0 ? this.tabsTwo.filter(function (ele) {
          return ele.name === _this0.activeNameTwo;
        })[0].label : '';
        id = this.activeNameTwo;
      }
      if (!name) return this.$message.error('请选择你要删除的类目');
      this.$confirm('是否确认删除"' + this.multiLanguageDisplay(name) + '"类目，以及"' + this.multiLanguageDisplay(name) + '"类目下的所有内容', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _rule.deleteMenu)({
          id: id
        }).then(function (res) {
          var dataRes = res.data;
          if (dataRes.errno === 0) {
            _this0.oldTabsOne = [];
            _this0.oldTabsTwo = [];
            _this0.getList();
            _this0.$message.success('删除成功');
          }
        });
      }).catch(function () {});
    },
    // 新增规则
    AddRule: function AddRule() {
      var _this1 = this;
      this.ruleForm = (0, _objectSpread2.default)({}, this.initRuleForm);
      if (this.activeNameOne && this.tabsOne.length > 0 && this.tabsOne.filter(function (ele) {
        return ele.name === _this1.activeNameOne;
      }).length > 0) {
        this.dialogTitle = '新增';
        this.dialogStatus = 'create';
        this.ruleFormVisible = true;
        // 在下一个事件循环中清除表单校验状态
        this.$nextTick(function () {
          if (_this1.$refs.ruleForm) {
            _this1.$refs.ruleForm.clearValidate();
          }
        });
      } else {
        return this.$message.error('需要新建一级类目');
      }
    },
    onSaveArticle: function onSaveArticle(type) {
      var _this10 = this;
      this.validateForm().then(function () {
        var urlLang = _this10.LanguageList.map(function (lang) {
          return lang.label;
        });
        var URL = {};
        urlLang.forEach(function (url) {
          URL[url] = _this10.ruleForm[url];
        });
        var params = {
          name: _this10.ruleForm.name,
          url: JSON.stringify(URL),
          status: _this10.ruleForm.status,
          menuId: _this10.activeNameTwo ? _this10.activeNameTwo : _this10.activeNameOne
        };
        if (type === 2 && _this10.ruleForm.id) {
          params.id = _this10.ruleForm.id;
        }
        (0, _rule.saveArticle)(params).then(function (res) {
          var dataRes = res.data;
          if (dataRes.errno === 0) {
            _this10.getRuleList();
            _this10.ruleForm = (0, _objectSpread2.default)({}, _this10.initRuleForm);
            _this10.ruleFormVisible = false;
            // 在下一个事件循环中清除表单校验状态
            _this10.$nextTick(function () {
              if (_this10.$refs.ruleForm) {
                _this10.$refs.ruleForm.clearValidate();
              }
            });
          }
        });
      }).catch(function (error) {
        console.error(error);
        // 表单验证失败，不进行保存操作
      });
    },
    onEnable: function onEnable(val, value) {
      var _this11 = this;
      var params = {
        id: value.id,
        name: value.name,
        url: value.url,
        status: value.status,
        menuId: this.activeNameTwo ? this.activeNameTwo : this.activeNameOne
      };
      (0, _rule.saveArticle)(params).then(function (res) {
        var dataRes = res.data;
        if (dataRes.errno === 0) {
          _this11.getRuleList();
        }
      });
    },
    // 验证表单并处理空值
    validateForm: function validateForm() {
      var _this12 = this;
      return new Promise(function (resolve, reject) {
        // 先手动触发所有必填字段的验证
        if (_this12.$refs.ruleForm) {
          _this12.$refs.ruleForm.validateField(['name', 'zh', 'en']);
        }

        // 然后进行完整表单验证
        _this12.$nextTick(function () {
          _this12.$refs.ruleForm.validate(function (valid) {
            if (valid) {
              // 对其他语种的空值进行处理
              var urlLang = _this12.LanguageList.map(function (lang) {
                return lang.label;
              });
              urlLang.forEach(function (url) {
                if (url !== 'zh' && url !== 'en' && !_this12.ruleForm[url]) {
                  _this12.ruleForm[url] = _this12.ruleForm.en;
                }
              });
              resolve(true);
            } else {
              reject(new Error('表单验证失败'));
            }
          });
        });
      });
    },
    // 关闭规则弹窗并重置表单
    closeRuleForm: function closeRuleForm() {
      var _this13 = this;
      this.ruleForm = (0, _objectSpread2.default)({}, this.initRuleForm);
      this.ruleFormVisible = false;
      // 在下一个事件循环中清除表单校验状态
      this.$nextTick(function () {
        if (_this13.$refs.ruleForm) {
          _this13.$refs.ruleForm.clearValidate();
        }
      });
    },
    // 验证特定字段
    validateField: function validateField(field) {
      var _this14 = this;
      // 确保表单引用存在
      if (this.$refs.ruleForm) {
        this.$nextTick(function () {
          _this14.$refs.ruleForm.validateField(field);
        });
      }
    }
  }
};